/** Operations hub — aligned with WhatsApp hub layout (whatsappUi.ts) */

export const opsPageWrap =
  'flex h-[calc(100dvh-5.5rem)] max-h-[calc(100dvh-5.5rem)] min-h-0 flex-col overflow-hidden rounded-none border-0 bg-white sm:min-h-[480px] sm:rounded-xl sm:border sm:border-gray-200 dark:bg-gray-900 dark:sm:border-gray-700';

export const opsShell = 'flex min-h-0 flex-1 overflow-hidden';

export const opsMobileTabs =
  'flex shrink-0 gap-0 overflow-x-auto border-b border-gray-200 bg-[#f0f2f5] dark:border-gray-700 dark:bg-[#202c33] [-webkit-overflow-scrolling:touch] md:hidden';

export const opsSubNavClass =
  'hidden w-14 shrink-0 flex-col items-center gap-1 overflow-y-auto border-r border-gray-200 bg-[#f0f2f5] py-3 dark:border-gray-700 dark:bg-gray-900/80 md:flex';

export const opsSubNavItem = (active: boolean) =>
  `flex h-10 w-10 items-center justify-center rounded-xl transition-colors ${
    active
      ? 'bg-primary-600 text-white shadow-sm'
      : 'text-gray-500 hover:bg-white hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white'
  }`;

export const opsAccentBadge = 'bg-primary-600/15 text-primary-600 dark:text-primary-400';

export const opsStatCard =
  'rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition hover:shadow-md dark:border-gray-700 dark:bg-gray-800';

export const opsChartCard =
  'rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:p-5';

export const opsSectionTitle = 'text-sm font-semibold text-gray-900 dark:text-white';

export const opsSectionDesc = 'mt-1 text-xs text-gray-500 dark:text-gray-400';

export const opsFilterClass =
  'w-full min-w-0 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-800 sm:w-auto';

export const opsPrimaryBtn =
  'inline-flex items-center justify-center gap-2 rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50';

export const opsSecondaryBtn =
  'inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200';

export const opsTableWrap = 'overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700';

export const opsLogViewer =
  'max-h-[520px] overflow-y-auto rounded-xl border border-gray-800 bg-[#0d1117] p-4 font-mono text-xs leading-relaxed text-emerald-400';

export const CHART_COLORS = {
  healthy: '#10b981',
  warning: '#f59e0b',
  critical: '#ef4444',
  down: '#dc2626',
  primary: '#2563eb',
  purple: '#8b5cf6',
  cyan: '#06b6d4',
  slate: '#64748b',
};

export const PIE_PALETTE = [
  '#2563eb',
  '#8b5cf6',
  '#06b6d4',
  '#10b981',
  '#f59e0b',
  '#ef4444',
  '#ec4899',
  '#64748b',
];

/** @deprecated use opsPageWrap */
export const opsPageWrapClass = '-mx-2 -my-2 sm:-mx-4 sm:-my-4 md:-mx-6 md:-my-6';
export const opsShellClass = opsShell;
export const opsSidebarClass = opsSubNavClass;
export const opsNavItemClass = opsSubNavItem;
export const opsMainClass = 'flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-white dark:bg-gray-900';
export const opsPanelHeaderClass = 'shrink-0 border-b border-gray-200 bg-white px-4 py-4 dark:border-gray-700 dark:bg-gray-900 sm:px-6';
export const opsPanelBodyClass = 'min-h-0 flex-1 overflow-y-auto p-4 sm:p-6';
export const opsCardClass = opsStatCard;
export const opsMetricGridClass = 'grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4';
export const opsToolbarClass = 'flex flex-wrap items-center gap-2';
export const opsInputClass = opsFilterClass;
export const opsPrimaryBtnClass = opsPrimaryBtn;
export const opsSecondaryBtnClass = opsSecondaryBtn;
export const opsTableWrapClass = opsTableWrap;
export const opsTableClass = 'min-w-full text-sm';
export const opsTableHeadClass = 'bg-gray-50 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:bg-gray-800/80 dark:text-gray-400';
export const opsLogViewerClass = opsLogViewer;

export function statusToChartColor(status: string): string {
  switch (status) {
    case 'healthy':
      return CHART_COLORS.healthy;
    case 'warning':
      return CHART_COLORS.warning;
    case 'critical':
    case 'down':
      return CHART_COLORS.critical;
    default:
      return CHART_COLORS.slate;
  }
}
